// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__Qid3y","button":"AboutUs_button__E6u5D","title":"AboutUs_title__uhyGQ"};